import * as ambassadorWixCloudAutocmsV3CollectionMetadata from './cloud-autocms-v3-collection-metadata-autocms.http.js';
import * as ambassadorWixCloudAutocmsV3CollectionMetadataTypes from './cloud-autocms-v3-collection-metadata-autocms.types.js';
import * as ambassadorWixCloudAutocmsV3CollectionMetadataUniversalTypes from './cloud-autocms-v3-collection-metadata-autocms.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createCollectionMetadata(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixCloudAutocmsV3CollectionMetadataUniversalTypes.CreateCollectionMetadataRequest,
  ambassadorWixCloudAutocmsV3CollectionMetadataTypes.CreateCollectionMetadataRequest,
  ambassadorWixCloudAutocmsV3CollectionMetadataUniversalTypes.CreateCollectionMetadataResponse,
  ambassadorWixCloudAutocmsV3CollectionMetadataTypes.CreateCollectionMetadataResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixCloudAutocmsV3CollectionMetadata.createCollectionMetadata(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/collection-metadata',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCollectionMetadata(): __PublicMethodMetaInfo<
  'GET',
  { dataCollectionId: string },
  ambassadorWixCloudAutocmsV3CollectionMetadataUniversalTypes.GetCollectionMetadataRequest,
  ambassadorWixCloudAutocmsV3CollectionMetadataTypes.GetCollectionMetadataRequest,
  ambassadorWixCloudAutocmsV3CollectionMetadataUniversalTypes.GetCollectionMetadataResponse,
  ambassadorWixCloudAutocmsV3CollectionMetadataTypes.GetCollectionMetadataResponse
> {
  const payload = { dataCollectionId: ':dataCollectionId' } as any;

  const getRequestOptions =
    ambassadorWixCloudAutocmsV3CollectionMetadata.getCollectionMetadata(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/collection-metadata/{dataCollectionId}',
    pathParams: { dataCollectionId: 'dataCollectionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateCollectionMetadata(): __PublicMethodMetaInfo<
  'PATCH',
  { dataCollectionId: string },
  ambassadorWixCloudAutocmsV3CollectionMetadataUniversalTypes.UpdateCollectionMetadataRequest,
  ambassadorWixCloudAutocmsV3CollectionMetadataTypes.UpdateCollectionMetadataRequest,
  ambassadorWixCloudAutocmsV3CollectionMetadataUniversalTypes.UpdateCollectionMetadataResponse,
  ambassadorWixCloudAutocmsV3CollectionMetadataTypes.UpdateCollectionMetadataResponse
> {
  const payload = { dataCollectionId: ':dataCollectionId' } as any;

  const getRequestOptions =
    ambassadorWixCloudAutocmsV3CollectionMetadata.updateCollectionMetadata(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v3/collection-metadata/{dataCollectionId}',
    pathParams: { dataCollectionId: 'dataCollectionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function replaceCollectionMetadata(): __PublicMethodMetaInfo<
  'PUT',
  {},
  ambassadorWixCloudAutocmsV3CollectionMetadataUniversalTypes.ReplaceCollectionMetadataRequest,
  ambassadorWixCloudAutocmsV3CollectionMetadataTypes.ReplaceCollectionMetadataRequest,
  ambassadorWixCloudAutocmsV3CollectionMetadataUniversalTypes.ReplaceCollectionMetadataResponse,
  ambassadorWixCloudAutocmsV3CollectionMetadataTypes.ReplaceCollectionMetadataResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixCloudAutocmsV3CollectionMetadata.replaceCollectionMetadata(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v3/collection-metadata',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteCollectionMetadata(): __PublicMethodMetaInfo<
  'DELETE',
  { dataCollectionId: string },
  ambassadorWixCloudAutocmsV3CollectionMetadataUniversalTypes.DeleteCollectionMetadataRequest,
  ambassadorWixCloudAutocmsV3CollectionMetadataTypes.DeleteCollectionMetadataRequest,
  ambassadorWixCloudAutocmsV3CollectionMetadataUniversalTypes.DeleteCollectionMetadataResponse,
  ambassadorWixCloudAutocmsV3CollectionMetadataTypes.DeleteCollectionMetadataResponse
> {
  const payload = { dataCollectionId: ':dataCollectionId' } as any;

  const getRequestOptions =
    ambassadorWixCloudAutocmsV3CollectionMetadata.deleteCollectionMetadata(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v3/collection-metadata/{dataCollectionId}',
    pathParams: { dataCollectionId: 'dataCollectionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listCollectionMetadata(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixCloudAutocmsV3CollectionMetadataUniversalTypes.ListCollectionMetadataRequest,
  ambassadorWixCloudAutocmsV3CollectionMetadataTypes.ListCollectionMetadataRequest,
  ambassadorWixCloudAutocmsV3CollectionMetadataUniversalTypes.ListCollectionMetadataResponse,
  ambassadorWixCloudAutocmsV3CollectionMetadataTypes.ListCollectionMetadataResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixCloudAutocmsV3CollectionMetadata.listCollectionMetadata(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/collection-metadata',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  CollectionMetadata as CollectionMetadataOriginal,
  PermissionsTemplateType as PermissionsTemplateTypeOriginal,
  PermissionsTemplateTypeWithLiterals as PermissionsTemplateTypeWithLiteralsOriginal,
  CreateCollectionMetadataRequest as CreateCollectionMetadataRequestOriginal,
  CreateCollectionMetadataResponse as CreateCollectionMetadataResponseOriginal,
  GetCollectionMetadataRequest as GetCollectionMetadataRequestOriginal,
  GetCollectionMetadataResponse as GetCollectionMetadataResponseOriginal,
  UpdateCollectionMetadataRequest as UpdateCollectionMetadataRequestOriginal,
  UpdateCollectionMetadataResponse as UpdateCollectionMetadataResponseOriginal,
  ReplaceCollectionMetadataRequest as ReplaceCollectionMetadataRequestOriginal,
  ReplaceCollectionMetadataResponse as ReplaceCollectionMetadataResponseOriginal,
  DeleteCollectionMetadataRequest as DeleteCollectionMetadataRequestOriginal,
  DeleteCollectionMetadataResponse as DeleteCollectionMetadataResponseOriginal,
  ListCollectionMetadataRequest as ListCollectionMetadataRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  ListCollectionMetadataResponse as ListCollectionMetadataResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateCollectionMetadataApplicationErrors as CreateCollectionMetadataApplicationErrorsOriginal,
  GetCollectionMetadataApplicationErrors as GetCollectionMetadataApplicationErrorsOriginal,
  UpdateCollectionMetadataApplicationErrors as UpdateCollectionMetadataApplicationErrorsOriginal,
} from './cloud-autocms-v3-collection-metadata-autocms.types.js';
